<template>
    <div>
        <el-tabs v-model="activeName"  type="border-card">
            <el-tab-pane label="周任务查看" name="0">
                <weekTask :sectionClassId="15"></weekTask>
            </el-tab-pane>
            <el-tab-pane label="周任务" name="1">
                <weekJobForm :sectionClassId="15"></weekJobForm>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import weekJobForm from '@/components/cooperative/weekJobForm'
    import weekTask from '@/components/cooperative/weekTask'

    //定义组件
    export default {
        data() {
            return {
                activeName:'0'
            }
        },
        components:{
            weekJobForm,
            weekTask

        },
    }
</script>


// WEBPACK FOOTER //
// src/views/cooperative/weekJob.vue